import { LOGIN_SUCCESS, LOGIN_FAIL } from './actionTypes';
import { saveUserAction, removeUser } from './userAction';
import { resetCart } from './cartAction';
import { resetCart as resetTruckCart } from './truckCartAction';
import { entryEditClearData } from './manualEntryEditAction';

import userReqHandler from '../../api/userRemote';

import User from '../../models/User';
import LoginModel from '../../models/Login';
import ApiResponse from '../../models/ApiResponse';
import ResponseError from '../../models/ResponseError';

import { receiveError } from './notificationAction';
import queueRemote from '../../api/queueRemote';

function loginSuccess() {
  return {
    type: LOGIN_SUCCESS
  }
}

function loginFail() {
  return {
    type: LOGIN_FAIL
  }
}

function loginAction(email: string, password: string) {

  return (dispatch: any) => {

    const loginObj: LoginModel = { email, password };

    userReqHandler.login(loginObj).then((res: ApiResponse<User>) => {

      const user: User | undefined = res.result;
      const error: ResponseError | undefined = res.error;

      if (user) {
        dispatch(saveUserAction(user));
        dispatch(loginSuccess());
        localStorage.setItem('user', JSON.stringify(user))
        
        try {
          const isStage = process.env.REACT_APP_STAGE === 'stage';
          if (isStage) {
            import('../../index').then(({ exportedTracker: tracker }) => {
              if (user.userId || user.email) {
                tracker.setUserID(user.userId ? user.userId.toString() : (user.email || ''));
              }
              if (user.stations) tracker.setMetadata('station', user.stations);
              if (user.email) tracker.setMetadata('email', user.email);
              const name = ((user.firstName || '') + ' ' + (user.lastName || '')).trim();
              if (name) tracker.setMetadata('name', name);
            });
          }
        } catch (e) {}

        // Matomo Tag Manager: Track user login
        window._mtm = window._mtm || [];
        window._mtm.push({
          event: 'user_login',
          userId: user.userId ? user.userId.toString() : user.email
        });
        
        // Set custom dimensions
        window._paq = window._paq || [];
        window._paq.push(['setCustomDimension', 1, user.email]);
        window._paq.push(['setCustomDimension', 2, (user.firstName + ' ' + user.lastName).trim()]);
        window._paq.push(['setCustomDimension', 3, user.stations || '']);
        window._paq.push(['trackPageView']);
      } 
      
      if (error) {
        dispatch(receiveError(error));
        dispatch(loginFail());
      }
    });
  };
}

function logoutAction() {

  return (dispatch: any) => {
    queueRemote.leaveCounter().then((resp: ApiResponse<any>) => {
      // handleCartResponse(resp, dispatch);
      userReqHandler.logout().then((res: ApiResponse<boolean>) => {

        const success: boolean | undefined = res.success;
        const error: ResponseError | undefined = res.error;
  
        if (success) {
          // Matomo Tag Manager: Track user logout
          window._mtm = window._mtm || [];
          window._mtm.push({
            event: 'user_logout'
          });
          
          dispatch(removeUser());
          dispatch(loginFail());
          dispatch(resetCart());
          dispatch(resetTruckCart());
          dispatch(entryEditClearData());
          localStorage.clear();
        } 
        
        if (error) {
          dispatch(receiveError(error));
        }
      });
    });
    
  };
}

export {
  loginAction,
  logoutAction,
  loginSuccess,
  loginFail
};
